import DeviceDetector from 'device-detector-js';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';
const deviceDetector = new DeviceDetector();

export const getBackend = () => {
    return deviceDetector.parse(navigator.userAgent).device?.type === 'desktop' ? HTML5Backend : TouchBackend;
};
